import { render, staticRenderFns } from "./CardCotacaoProdutosList.vue?vue&type=template&id=66f72511"
import script from "./CardCotacaoProdutosList.vue?vue&type=script&lang=js"
export * from "./CardCotacaoProdutosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports